import MapGeocoder from "./MapGeocoder";
import QueryMenu from "./QueryMenu";
import SettingCameraImage from "./SettingCameraImage";
import SettingMenu from "./SettingsMenu";
import MapSettings from "./MapSettings";
import { HStack } from "@chakra-ui/react";
import AccountSettings from "./AccountSettings";
import { useAppStore } from "../../../context/store";
import LiveTrace from "./LiveTrace";

function HeaderRight() {
  const imageGeojsonMode = useAppStore((s) => s.imageGeojsonMode);
  return (
    <HStack position={"absolute"} top={2} right={"80px"} p={1} zIndex={1005} gap={2}>
      <MapGeocoder />
      {imageGeojsonMode && <SettingCameraImage />}
      {/* <LiveTrace /> */}
      <QueryMenu />
      <SettingMenu />
      <MapSettings />
      <AccountSettings />
    </HStack>
  );
}

export default HeaderRight;
